import { render, staticRenderFns } from "./CardNav.vue?vue&type=template&id=24c7a48c&scoped=true&"
import script from "./CardNav.vue?vue&type=script&lang=js&"
export * from "./CardNav.vue?vue&type=script&lang=js&"
import style0 from "./CardNav.vue?vue&type=style&index=0&id=24c7a48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c7a48c",
  null
  
)

export default component.exports